export const CONSENT_ACCEPT = "Accept";
export const CONSENT_DECLINE = "Decline";
export const CONSENT_PROMPT_TYPE = "GDPR_ConsentForm";
